<mat-expansion-panel
    class="st-expansion-panel-panel"
    [togglePosition]="togglePosition"
    [hideToggle]="hideToggle"
    [expanded]="expanded"
    [class.st-expansion-panel-panel__mouse-entered]="mouseEntered"
    (mouseenter)="onMouseEnter()"
    (mouseleave)="onMouseLeave()"
    (opened)="panelOpened()"
    (closed)="panelClosed()">
    <mat-expansion-panel-header class="st-expansion-panel-panel-header">
        <ng-content select="[before]" />
        <ng-content select="[title]" />
        <ng-content select="[actions]" />
    </mat-expansion-panel-header>
    <ng-content />
</mat-expansion-panel>
